module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "jump back-to-top",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64aa8bbc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-jump/src/BackToTop.vue
// module id = 455
// module chunks = 40